import gql from 'graphql-tag';
import { parseToMutationRequestUser } from 'utils/utils';

export default data => {
  // create shallow copy of data
  const cleanedData = { ...data };

  // filter out roles without roleId
  if (cleanedData.roles && Array.isArray(cleanedData.roles)) {
    cleanedData.roles = cleanedData.roles.filter(role => role && role.roleId && role.roleId !== '');
  }

  // samething for roleGroups
  if (cleanedData.roleGroups && Array.isArray(cleanedData.roleGroups)) {
    cleanedData.roleGroups = cleanedData.roleGroups.filter(rg => rg && rg.roleGroupId && rg.roleGroupId !== '');
  }

  const isCreateUser = true;
  const dataCreate = parseToMutationRequestUser(
    cleanedData,
    ['status', 'type', 'index'],
    isCreateUser,
  );
  const createUser = `createUser(input: ${dataCreate})`;
  return gql`
    mutation {
      ${createUser} {
        id
      }
    }
  `;
};
